import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
	onClose?: () => void;
	icon?: IconProp;
}

export const WidgetCloseButton = (props: Props): React.ReactElement => {
	const { onClose, icon } = props;
	return (
		<FontAwesomeIcon
			icon={icon}
			className="ui-widget-close-modal-icon"
			onClick={onClose}
		/>
	);
};
